export const textStyles = {
  body: {
    fontSize: "md",
    fontWeight: "medium",
  },
  paragraph: {},
  large: {
    fontSize: "lg",
    fontWeight: "medium",
  },
  small: {
    fontSize: "sm",
    fontWeight: "medium",
  },
  label: {
    fontSize: "sm",
    fontWeight: "semibold",
    color: "gray.700",
  },
  h1: {
    fontSize: "3xl",
    fontWeight: "bold",
  },
  h2: {},
  h3: {},
  h4: {},
  h5: {},
  h6: {},
};
